import React from 'react';
import { createRoot } from 'react-dom/client';
import '@cwos/design-tokens/css/tokens.css';
import './app.css';
import { App, API_BASE } from './App.js';
import { AcceptInvitation } from './screens/AcceptInvitation.js';

const container = document.getElementById('root');
if (!container) throw new Error('Root container missing from index.html');

/**
 * NO ERROR REPORTING TRANSPORT, DELIBERATELY.
 *
 * `apps/admin/src/main.tsx` installs `installClientErrorReporting`, which POSTs
 * client errors to the customer API. This console must not: a stack trace from
 * a screen holding a platform credential is exactly the kind of payload that
 * ends up carrying one, and the console has no error sink of its own until
 * ADR 0015's `apps/platform-api` exists. Errors surface in the operator's own
 * console and nowhere else, which is the smaller failure.
 */
createRoot(container).render(
  <React.StrictMode>
    {/* A staff invitation is accepted WITHOUT any console credential, so it is
        its own root: the operator gate and admission never run for it. */}
    {window.location.pathname === '/accept-invitation' ? (
      <main className="gate">
        <div className="gate-inner">
          <div className="gate-brand">
            <span className="brand-mark" aria-hidden="true">
              <img src="/brand/phibian-mark.svg" alt="" />
            </span>
            Phibian Console
          </div>
          <AcceptInvitation apiBase={API_BASE} />
        </div>
      </main>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
